/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Базовая форма с загрузкой фото в претензиях
   */
  app.ClaimUploadFormView = app.FormView.extend({
    formElement: '.field',
    fileSizeLimit: 2097152,
    fileTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'],
    run: function () {
      app.FormView.prototype.run.apply(this, arguments);
      this.photoTemplate = app.helpers.TemplateHelper.getTemplate('#photo-template');
      this.uploadOptions = _.extend(this.uploadOptions, {
        fileField: 'file_path',
        itemIdField: 'claim_item_id',
        urlRoot: '/api/v3/claim-item-photo/'
      });
    },
    /**
     * Валидация фотографий
     * @inheritDoc
     */
    _validateFile: function (file) {
      var $caption = this.$('.photo-caption');
      if (file.size > this.fileSizeLimit || this.fileTypes.indexOf(file.type) === -1) {
        $caption.removeClass('not_display');
        return false;
      }
      $caption.addClass('not_display');
      return true;
    },
    /**
     *  Рендер фотографий
     * @inheritDoc
     */
    _renderFilePreview: function (file, itemId) {
      var $thumbnails = this.$('.photo-thumbnails'),
        url = window.URL.createObjectURL(file);
      $thumbnails.append($(this.photoTemplate({
        id: itemId,
        url: url
      })));
    },
    /**
     * Вставка фото в разметку
     * inheritDoc@
     */
    _uploadSuccess: function (data, loaded) {
      this.setPhotoToModel(data);
      var newPhoto = this.$('.claim-photo-block[data-photo-id="' + this.model.get('id') + '"]');
      newPhoto.attr('data-photo-id', data.id);
      if (loaded) {
        loaded.push(data);
      }
    },

    /**
     * Сет фотографий в модель
     * inheritDoc@
     */
    setPhotoToModel: function (data) {
      var photos = this.model.get('photos');
      if (!_.isArray(photos)) {
        this.model.set('photos', []);
      }
      photos.push(data);
      this.model.set('photos', photos);
    }
  });
})();

}.call(window));